$(document).ready(function () {
    function news_scroll() {
        const h = $('#featured-news-data').height();
        const h_service = $("#service-container-content").height();
        const w = $(window).width();
        if (h > 320) {
            if (w >= 1280) {
                $("#news-list-box").height(h < h_service ? h_service : (h > 600 ? 600 : h));
            } else if (w >= 768 && w < 1280) {
                $("#news-list-box").height(h);
            }
        } else {
            $("#news-list-box").height(320);
        }
    }

    news_scroll();
    $(window).on('resize', function () {
        news_scroll();
    });
    window.Scrollbar.initAll({
        damping: 0.1,
        thumbMinSize: 10,
        alwaysShowTracks: true,
        continuousScrolling: true,
    })
    const advHeaderData = new Swiper(".adv-header-data", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        speed: 600,
        slidesPerView: 1,
        grid: {
            rows: 1,
            fill: 'row',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
    const navigatorList = new Swiper('.navigator-list',{
        speed: 600,
        spaceBetween : 16,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        grid: {
            rows: 4,
            fill: 'row' 
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                grid: {
                    rows: 4,
                    fill: 'row' 
                },
            },
            1280: {
                slidesPerView: 3,
                grid: {
                    rows: 4,
                    fill: 'row' 
                },
            },
        }
    });
    const videoData = new Swiper(".video-data", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        speed: 600,
        slidesPerView: 1,
        grid: {
            rows: 1,
            fill: 'row',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const serviceData = new Swiper(".services-data", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 600,
        loop: true,
        allowSlidePrev: true,
        allowSlideNext: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            enabled: true,
        }
    });

    // serviceData.on('slideNextTransitionEnd',function(){
    //     if($(".swiper-button-next").hasClass("swiper-button-disabled")){
    //         $(".swiper-button-next").removeClass("swiper-button-disabled");
    //         $(".swiper-button-next").attr("aria-disabled", "false");
    //     }
    // })

    const sponsorData = new Swiper(".sponsor", {
        slidesPerView: 1,
        grid: {
            rows: 1,
            fill: 'row',
        },
        speed: 600,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const documentData = new Swiper('.document-data', {
        slidesPerView: 3,
        grid: {
            rows: 1,
            fill: 'row',
        },
        speed: 600,
        spaceBetween: 20, // khoảng cách giữa các item
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            250: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        }
    });

    const partnerData = new Swiper('.partner-list', {
        slidesPerView: 5, // số lượng cột (item trên 1 hàng)
        grid: {
            rows: 1,        // số hàng
            fill: 'row',    // mặc định 'column', đổi thành 'row' cho đúng ý
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        speed: 600,
        spaceBetween: 20, // khoảng cách giữa các item
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            250: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 5,
            },
        }
    });

    // const pollData = new Swiper(".poll-data", {
    //     slidesPerView: 1,
    //     grid: {
    //         rows: 1,
    //         fill: 'row',
    //     },
    //     speed: 600,
    //     autoplay: {
    //         delay: 5000,
    //         disableOnInteraction: true,
    //     },
    //     pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true,
    //     },
    // });

    //--Phần hoạt động chuyên môn và tài liệu--
    function formatDateTime(dateString) {
        if (!dateString) return "N/A";

        const date = new Date(dateString);
        const pad = (num) => num.toString().padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    function slugWithTitleAndId(title,id){
        return `${slugify(title)}-${id}`;
    }
    function slugify(title){
        const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
        const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')
        return title.toString().toLowerCase()
        .replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a')
        .replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e')
        .replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i')
        .replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o')
        .replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u')
        .replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y')
        .replace(/đ/gi, 'd')
        .replace(/\s+/g, '-') 
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    }

    const noDataMessage = $("#noDataMessage").val();
    const viewDetailsMessage = $("#viewDetailsMessage").val();
    const viewAllMessage = $("#viewAllMessage").val();
    const labelCode = $("#labelCode").val();
    const labelPublishingUnit = $("#labelPublishingUnit").val();
    const labelAuthor = $("#labelAuthor").val();

    function fetchArticles(listElement, alias, locale, url, params, renderCallback) {
        listElement.html('<div class="loading-spinner"></div>');
        $.ajax({
            url: `${url}?${params.toString()}`,
            method: "GET",
            dataType: "json",
            success: function (response) {
                const data = Object.values(response.data);
                renderCallback(listElement, alias, locale, data);
            },
            error: function () {
                listElement.html(`
                    <div class="no-data">
                        <p class="no-data-message">${noDataMessage}</p>
                    </div>
                `);
            },
        });
    }
    function renderIntroductionArticle(listElement, alias, locale, articles){
        if (!articles.length) {
            listElement.html('');
            return;
        }
        const article = articles[0];
        const introductionArticleHtml = `
        <article class="featured-introduction-article">
            <div class="article-container" data-scrollbar>
                <h3 class="article-header">
                    ${article.title}             
                </h3>
                <div class="article-content">
                    ${article.content}         
                </div>
            </div>
        </article>`
        listElement.html(introductionArticleHtml);
        const introductionItem = document.querySelector('.featured-introduction-article .article-container');
        if (introductionItem) {
            Scrollbar.init(introductionItem,{
            damping: 0.1,
            thumbMinSize: 10,
            alwaysShowTracks: true,
            continuousScrolling: true,
            });
        }
    }
    function renderActivityArticles(listElement, alias, locale, articles) {
        if (!articles.length) {
            const existingIntroduction = listElement.find('.featured-news-article-introduction');
            const noDataHtml = `
                <div class="no-data news-item">
                    <p class="no-data-message">${noDataMessage}</p>
                </div>
            `;

            if (existingIntroduction.length) {
                listElement.find('.news-item, .featured-news-list-more').remove();
                listElement.append(noDataHtml);
            } else {
                listElement.html(noDataHtml);
            }
            return;
        }
        
        const baseUrl = `/${locale}/professional-activities/${alias}`;
        let articlesHtml = articles.map(article => {
            const articleTitle = locale === 'vi' ? article.title : article.title_en ?? article.title;
            const articleUrl = `${baseUrl}/${slugWithTitleAndId(articleTitle, article._id)}`;
            return `
                <li class="news-item">
                    <span class="news-content">
                        <a href="${articleUrl}" class="news-title" title="${articleTitle}">${articleTitle}</a>
                    </span>
                </li>
            `;
        }).join('');
        articlesHtml = `<ul class="featured-news-list">${articlesHtml}</ul>` 
        const moreLinkHtml = `
            <div class="featured-news-list-more">
                <a href="${baseUrl}" class="read-more">${viewAllMessage}</a>
            </div>
        `;

        const existingIntroduction = listElement.find('.featured-news-article-introduction');
        if (existingIntroduction.length) {
            listElement.find('.news-item, .featured-news-list-more').remove();
            listElement.append(articlesHtml + moreLinkHtml);
        } else {
            listElement.html(articlesHtml + moreLinkHtml);
        }
    }

    function renderDocumentArticles(listElement, alias, locale, articles) {
        if (!articles || articles.length === 0) {
            listElement.html(`
            <div class="no-data">
                <p class="no-data-message">${noDataMessage}</p>
            </div>
        `);
            return;
        }

        const baseUrl = `/${locale}/documents/${alias}`;
        const articleHTML = articles.map(article => {
            const categoryName = article.document_type
                ? (locale === "en" ? article.document_type.nameEn : article.document_type.name)
                : "";

            const publishingUnitName = article.publishing_unit
                ? (locale === "en" ? article.publishing_unit.nameEn : article.publishing_unit.name)
                : "";

            const articleUrl = article.file_url || `${baseUrl}/${slugWithTitleAndId(article.title, article._id)}`;
            const targetAttr = article.file_url ? "_blank" : "_self";

            return `
            <div class="document-container-item swiper-slide">
                <div class="featured-news-layer-card">
                    <div class="news-image-wrapper">
                        <img src="${article.image}" alt="${article.title}" title="${article.title}"
                             onerror="this.onerror=null;this.src='/themes/vdd/assets/images/image_default.png';">
                    </div>
                    <div class="news-content">
                        <div class="news-date-cate">
                            <div class="news-date">
                                <i class="fa-regular fa-calendar"></i> ${formatDateTime(article.published_at)}
                            </div>
                            ${categoryName ? `<a href="javascript:void(0);" class="news-category">${categoryName}</a>` : ""}
                        </div>
                        <div class="news-title">
                            <a href="${articleUrl}" target="${targetAttr}" title="${article.title}">
                                ${article.title}
                            </a>
                        </div>
                        ${article.code ? `<div class="news-code" title="${article.code}">${labelCode}: ${article.code}</div>` : ""}
                        ${publishingUnitName ? `<div class="news-code" title="${publishingUnitName}">${labelPublishingUnit}: ${publishingUnitName}</div>` : ""}
                        ${article.author_name ? `<div class="news-code" title="${article.author_name}">${labelAuthor}: ${article.author_name}</div>` : ""}
                        <a href="${articleUrl}" class="news-link" target="${targetAttr}" title="${article.title}">
                            ${viewDetailsMessage}
                        </a>
                    </div>
                </div>
            </div>
        `;
        }).join('');

        listElement.html(articleHTML);
    }

    const activityListCompound = $("#activities-cate-news-container.featured-news-list-compound");
    const activityTabBtn = $(".activities-cate-item");
    const activityLocale = activityListCompound.data("locale");
    let activityAlias = activityTabBtn.filter(".active").data("alias");
    let introductionAlias = activityTabBtn.filter(".active").data("introduction-alias");
    const introductionArticleContainer = activityListCompound.find('.featured-introduction-article-container');
    const activityList = activityListCompound.find('.featured-news-list-container');
    fetchArticles(introductionArticleContainer, activityAlias, activityLocale ?? "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
        catAlias: introductionAlias,
        typeTrans: activityLocale || "vi",
        pageSize: 1
    }), renderIntroductionArticle);
    fetchArticles(activityList, activityAlias, activityLocale ?? "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
        catAlias: activityAlias,
        typeTrans: activityLocale || "vi",
        pageSize: 6
    }), renderActivityArticles);
    

    $(".activities-cate-list").on("click", ".activities-cate-item", function () {
        activityTabBtn.removeClass("active");
        $(this).addClass("active");
        activityAlias = $(this).data("alias");
        introductionAlias = $(this).data("introduction-alias");
        fetchArticles(introductionArticleContainer, activityAlias, activityLocale ?? "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
            catAlias: introductionAlias,
            typeTrans: activityLocale || "vi",
            pageSize: 1
        }), renderIntroductionArticle);
        fetchArticles(activityList, activityAlias, activityLocale || "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
            catAlias: activityAlias,
            typeTrans: activityLocale || "vi",
            pageSize: 6
        }), renderActivityArticles);
    });

    const documentListId = $("#document-list");
    const posDocumentList = $("#document-list .swiper-wrapper");
    const documentLocale = documentListId.data("locale");
    let documentAlias = $(".tab-link.active").data("alias");
    fetchArticles(posDocumentList, documentAlias, documentLocale || "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
        catAlias: documentAlias,
        typeTrans: documentLocale || "vi",
        pageSize: 8,
        'typeTable[]': 'documents'
    }), renderDocumentArticles);

    $(".tab-links").on("click", ".tab-link", function () {
        $(".tab-link").removeClass("active");
        $(this).addClass("active");
        documentAlias = $(this).data("alias");
        fetchArticles(posDocumentList, documentAlias, documentLocale || "vi", "/api/fe/article/getPaginateFE", new URLSearchParams({
            catAlias: documentAlias,
            typeTrans: documentLocale || "vi",
            pageSize: 8,
            'typeTable[]': 'documents'
        }), renderDocumentArticles);
    });
    //--kết thúc phần hoạt động chuyên môn và tài liệu--
});


// bắt đầu jquery poll
$(document).ready(function () {
    const locale = $('#locale').val();
    const messages = {
        vi: {
            voted: 'Đã bình chọn',
            selectOption: 'Vui lòng chọn một đáp án trước khi bình chọn!',
            error: 'Có lỗi xảy ra khi gửi bình chọn!',
            defaultError: 'Có lỗi xảy ra khi bình chọn!'
        },
        en: {
            voted: 'Voted',
            selectOption: 'Please select an option before voting!',
            error: 'An error occurred while submitting your vote!',
            defaultError: 'An error occurred while voting!'
        }
    };
    const lang = messages[locale] || messages['vi'];

    // Kiểm tra trạng thái đã vote cho từng poll khi load trang
    $('.poll-form').each(function () {
        const $form = $(this);
        const pollId = $form.find('.pollId').val();
        const hasVoted = localStorage.getItem(`poll_${pollId}_voted`);

        if (hasVoted) {
            $form.find('.poll-option').prop('disabled', true);
            $form.find('.btn-vote').prop('disabled', true)
                .text(lang.voted)
                .css({'background-color': '#ccc', 'cursor': 'not-allowed'});

            $.ajax({
                url: `/admin/manager/vdd/pollVote/getPollVote`,
                method: 'GET',
                data: {pollId: pollId},
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                success: function (data) {
                    if (data.success) {
                        $.each(data.results, function (key, percentage) {
                            const resultItem = $form.find(`#result-${pollId}-${key}`);
                            resultItem.css('display', 'flex');
                            resultItem.find('.progress-bar').css('width', `${percentage}%`);
                            resultItem.find('.percentage').text(`${percentage}%`);
                        });
                    }
                }
            });
        }
    });

    // Xử lý submit khi nhấn button vote
    $('.poll-form').submit(function (e) {
        e.preventDefault();

        const $form = $(this);
        const pollId = $form.find('.pollId').val();
        const selectedOption = $form.find(`input[name="pollOption-${pollId}"]:checked`).val();

        if (!selectedOption) {
            alert(lang.selectOption);
            return;
        }

        $.ajax({
            url: '/admin/manager/vdd/pollVote/apiVote',
            method: 'POST',
            contentType: 'application/json',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            data: JSON.stringify({
                pollId: pollId,
                answerKey: selectedOption
            }),
            success: function (data) {
                if (data.success) {
                    localStorage.setItem(`poll_${pollId}_voted`, 'true');
                    $form.find('.poll-option').prop('disabled', true);
                    $form.find('.btn-vote').prop('disabled', true)
                        .text(lang.voted)
                        .css({'background-color': '#ccc', 'cursor': 'not-allowed'});
                    $.each(data.results, function (key, percentage) {
                        const resultItem = $form.find(`#result-${pollId}-${key}`);
                        resultItem.css('display', 'flex');
                        resultItem.find('.progress-bar').css('width', `${percentage}%`);
                        resultItem.find('.percentage').text(`${percentage}%`);
                    });
                } else {
                    alert(data.message || lang.defaultError);
                }
            },
            error: function () {
                alert(lang.error);
            }
        });
    });
});
